import {
  SerializedLegacyAttributeCompareFilter,
  SerializedLegacyAttributeFilter,
} from 'cio/types/conditions/legacy-filter';
import { deserializeFilter as deserializeAttribute } from 'cio/utils/conditions/deserialize/attribute';

// Attribute compare conditions are of the form:
// {
//   "type": "attribute_compare",
//   "field_source": "event_attribute/customer_attribute",
//   "value_source": "event_attribute/customer_attribute",
//   "operator": operator,
//   "field: field name,
//   "value": some value
// }
//
// In the UI, we deserialize them into Attribute or EventAttribute models, since
// we use the ConditionEditor::Attribute component to edit them all.

export default function (condition: SerializedLegacyAttributeCompareFilter) {
  let attributeCondition: SerializedLegacyAttributeFilter = {
    field: condition.field,
    operator: condition.operator,
    value: condition.value,
    value2: condition.value2,
    comparison_operator: condition.value_source,
    inverse: condition.inverse,
    collectionSchema: condition.collectionSchema,
    event: condition.event,
  };

  if (condition.field_source && ['event_attribute', 'collection_attribute'].includes(condition.field_source)) {
    attributeCondition.type = condition.field_source;
  }

  if (condition.field_source === 'customer_attribute') {
    attributeCondition.type = 'attribute';
  }

  if (condition.field_source === 'foreign_event_attribute') {
    attributeCondition.type = 'event_attribute';
  }

  return deserializeAttribute(attributeCondition);
}
